module.exports = __webpack_public_path__ + "static/media/shorting.d7d9b101.svg";